import React from 'react'
import PropTypes from 'prop-types'
import { capitalize } from 'lodash'
import { FormControl, RadioGroup, FormControlLabel, Radio, FormHelperText } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import T from 'T'
import { EVENT_INSTANCE_TYPES } from 'settings/constants/service'

const EventInstanceTypeRadioGroup = ({ name, value: propValue, onChange: propOnChange, disabled = false, showError = true }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext()

  // Use prop value/onChange if provided (from Controller), otherwise use form context
  const value = propValue !== undefined ? propValue : watch(name)
  const eventInstanceError = errors?.[name]?.message

  const handleChange = event => {
    if (propOnChange) {
      propOnChange(event.target.value)
    } else {
      setValue(name, event.target.value)
    }
  }

  return (
    <FormControl error={Boolean(eventInstanceError)} component="fieldset" sx={{ width: '100%' }}>
      <RadioGroup
        row
        value={value}
        onChange={handleChange}
        aria-label="event instance type"
        name={name}
        sx={{
          width: '100%',
        }}
      >
        <FormControlLabel
          value={EVENT_INSTANCE_TYPES.DAY_OF_WEEK}
          control={<Radio disabled={disabled} />}
          label={capitalize(T.DAY_OF_WEEK)}
          sx={{
            flex: 1,
            margin: 0,
          }}
        />
        <FormControlLabel
          value={EVENT_INSTANCE_TYPES.SPECIFIC_DATE}
          control={<Radio disabled={disabled} />}
          label={capitalize(T.SPECIFIC_DATE)}
          sx={{
            flex: 1,
            margin: 0,
          }}
        />
      </RadioGroup>
      {showError && eventInstanceError && <FormHelperText error>{eventInstanceError}</FormHelperText>}
    </FormControl>
  )
}

EventInstanceTypeRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  showError: PropTypes.bool,
}

export default EventInstanceTypeRadioGroup
